const statusClassMap = {
  1: "status available",
  2: "status busy",
  3: "status out",
  4: "status vacation",
};

const StatusDot = ({ statusCode }) => {
  const className = statusClassMap[statusCode] || "status";

  return <span className={className}></span>;
};

export default StatusDot;